import React from "react";
import roundText from '../../../../src/assets/images/round-text.png'
import AboutApi from "../../../Data/HomePage/AboutApi";

function HomeHeroSection() {
  return (
    <>
      <section className="hero-section page-section scroll-to-page" id="home">
        <div className="custom-container">
          <div className="hero-content content-width">
            <div className="section-header">
              <h4
                className="subtitle scroll-animation"
                data-animation="fade_from_bottom"
              >
                <i className={AboutApi.introduction.titleTag.icon}></i> {AboutApi.introduction.titleTag.title}
              </h4>
              <h1
                className="scroll-animation"
                data-animation="fade_from_bottom"
              >
                {AboutApi.introduction.hello} <span>{AboutApi.introduction.name}</span>, {AboutApi.introduction.designation}
              </h1>
            </div>
            <p className="scroll-animation" data-animation="fade_from_bottom">
             {AboutApi.introduction.tagLine}
            </p>
            <a
              href="#portfolio"
              className="go-to-project-btn scroll-to scroll-animation"
              data-animation="rotate_up"
            >
              <img src={roundText} alt="Rounded Text" />
              <i className="las la-arrow-down"></i>
            </a>

            {/* <div className="facts d-flex">
              <div
                className="left scroll-animation"
                data-animation="fade_from_left"
              >
                <h1>5+</h1>
                <p>
                  Years of <br />
                  Experience
                </p>
              </div>
              <div
                className="right scroll-animation"
                data-animation="fade_from_right"
              >
                <h1>182+</h1>
                <p>
                  projects completed on <br />
                  15 countries
                </p>
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
}

export default HomeHeroSection;
